export default __webpack_public_path__ + "static/media/Home.34f7bdfa.svg";